var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DefaultHandlerProvider, Environment } from 'relay-runtime';
import { createNetwork } from './network';
import { createStore } from './store';
import { DEFAULT_CACHE_OPTIONS } from '../constants';
function initEnvironment(_a) {
    var _b = _a.handlerProvider, handlerProvider = _b === void 0 ? DefaultHandlerProvider : _b, _c = _a.network, middlewares = _c.middlewares, options = _c.options, store = _a.store, environmentOptions = _a.environmentOptions;
    var cacheOptions = (options === null || options === void 0 ? void 0 : options.cacheOptions) || DEFAULT_CACHE_OPTIONS;
    store = store || createStore();
    return new Environment(__assign(__assign({}, (environmentOptions && __assign({}, environmentOptions))), { handlerProvider: handlerProvider, network: createNetwork(middlewares, __assign(__assign({ minification: process.env.QUERY_MINIFICATION === 'true' }, options), { cacheOptions: cacheOptions })), store: store }));
}
export { initEnvironment };
//# sourceMappingURL=environment.js.map